/**
 * @generated SignedSource<<448413b5fd0560e7708fbec5001a0278>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionCardCarouselRelayFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly collectionId: string;
      readonly " $fragmentSpreads": FragmentRefs<"collectionCardRelayFragment">;
    };
  }>;
  readonly " $fragmentType": "collectionCardCarouselRelayFragment";
};
export type collectionCardCarouselRelayFragment$key = {
  readonly " $data"?: collectionCardCarouselRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionCardCarouselRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionCardCarouselRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateCollectionResultEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformTemplateCollection",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "collectionId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "collectionCardRelayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateCollectionContentSearchConnection",
  "abstractKey": null
};

(node as any).hash = "cc3e4db88f751878185d865c8fde82f6";

export default node;
